
export default class LoaderController {

	constructor (Loader) {
		// dependencies
		this.Loader = Loader;

		// data
		this.image = require('./loader.svg');
	}

	isOpened () {
		return this.Loader.isOpened();
	}

}

LoaderController.$inject = ['Loader'];



// WEBPACK FOOTER //
// ./src/directive/loader/loader.controller.js